import Mutations from '../../odata/mutations';

export default { ...new Mutations('completedTaskComment'), ...new Mutations('completedTaskComments') };
